import { type Form, Input } from 'antd';
import type { ComponentProps } from 'react';
import type { TextAreaProperties } from '../../input';
import { Item } from '../item';

const { TextArea } = Input;

export type TextAreaItemProperties = {
  hidden?: boolean;
} & Omit<ComponentProps<typeof Form.Item>, 'children'>;

type P = {
  input?: TextAreaInputProperties;
  item: TextAreaItemProperties;
};

type TextAreaInputProperties = {
  'data-test-id'?: string;
} & TextAreaProperties;

/**
 * @deprecated Use TextArea instead with Form.Item
 */
const TextAreaInput = ({ input, item }: P) => (
  <Item {...item}>
    <TextArea rows={4} size="large" {...input} />
  </Item>
);

export default TextAreaInput;
